import { MessageSquare } from 'lucide-react'
import { useRouterState } from '@tanstack/react-router'
import { Badge } from '@/shared/components/ui/badge'
import { useChatBadge, useChatCapabilities } from '@/entities/chat'
import { useChatDockControls } from './useChatDockControls'

export function ChatButton() {
  const routerState = useRouterState()
  const isChatRoute = routerState.location.pathname.startsWith('/chat')
  const { enabled: permitted } = useChatCapabilities()
  const { toggleDock } = useChatDockControls()
  const unreadCount = useChatBadge()

  if (!permitted || isChatRoute) return null

  return (
    <button
      type="button"
      onClick={() => toggleDock()}
      aria-label="Chat"
      className="relative flex h-9 w-9 items-center justify-center rounded-md text-ink-2 hover:bg-hover"
    >
      <MessageSquare size={15} strokeWidth={1.6} />
      {unreadCount > 0 && (
        <Badge
          tone="bad"
          className="absolute -right-0.5 -top-0.5 h-4 min-w-4 justify-center rounded-full px-1 py-0 text-[10px] leading-none"
        >
          {unreadCount > 9 ? '9+' : unreadCount}
        </Badge>
      )}
    </button>
  )
}
